import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const templatePreviewStyle = css`
  background: ${theme.colors.neutral10};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(2)};
`;
